import { SuperuserSkillImportPage } from "@/features/superuser/skills/superuser-skill-import.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/skills/import")({
  component: SuperuserSkillImportPage,
});
